import React, { useState,useEffect } from "react";
import { useForm } from "react-hook-form";
import NewOrderFileUploadDialog from "./NewOrderFileUploadDialog";

export default function NewOrderForm(props) {
    console.log("props.accountType",props.accountType)
    const [showDialog, setShowDialog] = useState(false);
    const [fileData, setFileData] = useState(null);

    const handleFileUpload = (data) => {
        setFileData(data);
    };

    const handleBulkOrdersClick = () => {
        setShowDialog(true);
    };

    const handleDialogClose = (data) => {
        setShowDialog(false);
        if (data) {
            handleFileUpload(data);
        }
    };

    const [etkKits, setEtkKits] = useState(props.kits);
    const { register, handleSubmit, watch, formState } = useForm({
        defaultValues: props.model,
        etkKits: props.kits,
        mode: "onChange",
    });
    
    useEffect(() => {
        setEtkKits(props.kits);
    }, [props.model, props.kits]);

    let orderType = watch("orderType");

    const renderMicroFields = () => {
        props.model.payType = '';
        return (
            <>
                <div className="columns">
                    <div className="column">
                        <label htmlFor="" className="label">
                            Type
                        </label>
                    </div>
                    <div className="column">
                        <select
                            className="input"
                            {...register("sampleType", { required: true })}
                        >
                            <option value="Pool">Pool</option>
                            <option value="Coliform">Coliform</option>
                            <option value="Ecoli">Ecoli</option>
                        </select>
                    </div>
                </div>
                <div className="columns">
                    <div className="column">
                        <label htmlFor="" className="label">
                            Sample Count
                        </label>
                    </div>
                    <div className="column">
                        <input
                            type="number"
                            className="input"
                            {...register("sampleCount", { required: true, min: 1 })}
                        />
                    </div>
                </div>
            </>
        );
    };

    const renderTestKitFields = () => {
        return (
            <>
                <div className="columns">
                    <div className="column">
                        <label htmlFor="" className="label">
                            Kit Type
                        </label>
                    </div>
                    <div className="column">
                        <select className="input" {...register("sampleType", { required: true })}>
                            {etkKits.map((u, index) => {
                                const capitalizedOption = u.vlpName.charAt(0).toUpperCase() + u.vlpName.slice(1).toLowerCase();
                                return (
                                    <option key={index} value={u.vlpName}>
                                        {capitalizedOption}
                                    </option>
                                );
                            })}
                        </select>
                    </div>
                </div>

                <div className="columns">
                    <div className="column">
                        <label htmlFor="" className="label">
                            Pay Type
                        </label>
                    </div>
                    <div className="column">
                        <select
                            className="input"
                            {...register("payType", { required: true })}
                        >
                            <option value=""></option>
                            <option value="pre-pay">At Purchase</option>
                            <option value="post-pay">After Purchase</option>
                        </select>
                    </div>
                </div>

                <div className="columns">
                    <div className="column">
                        <label htmlFor="" className="label">
                            Test Kit Count
                        </label>
                    </div>
                    <div className="column">
                        <input
                            type="number"
                            className="input"
                            {...register("sampleCount", { required: true, min: 1 })}
                        />
                    </div>
                </div>
            </>
        );
    };

    return (
        <>
            <form onSubmit={handleSubmit(props.onSubmit)}>
                <div className="columns is-desktop">
                    <div className="column">
                        <div className="columns">
                            <button type="button" className="button is-primary" onClick={handleBulkOrdersClick}>
                                Bulk Orders using File
                            </button>
                        </div>
                        <hr />
                        <div className="columns">
                            <div className="column">
                                <label htmlFor="" className="label">
                                    Sample Type
                                </label>
                            </div>
                            <div className="column">
                                <select
                                    className="input"
                                    {...register("orderType", { required: true })}
                                >
                                    <option value=""></option>
                                    {props.accountType?.toLowerCase().trim().includes("etk") ? (
                                    <option value="ETK">ETK</option>
                                    ) : (
                                    [
                                        <option key="Micro" value="Micro">Micro</option>,
                                        <option key="Chemistry" value="Chemistry">Chemistry</option>
                                    ]
                                    )}
                                </select>
                                </div>
                        </div>
                        {orderType === "Micro" && renderMicroFields()}
                        {orderType === "ETK" && renderTestKitFields()}
                        {orderType === "Chemistry" && (
                            <>
                                <div className="columns">
                                    <div className="column">
                                        <label htmlFor="" className="label">
                                            Sample Count
                                        </label>
                                    </div>
                                    <div className="column">
                                        <input
                                            type="number"
                                            className="input"
                                            {...register("sampleCount", { required: true, min: 1 })}
                                        />
                                    </div>
                                </div>
                            </>
                        )}
                        <div className="column">
                            {props.orderNumber && orderType === "ETK" && (
                                <>
                                    <button
                                        className="button is-primary"
                                        onClick={props.handlePrintOrderNumberQRLabels}
                                        type="button"
                                    >
                                        Print Order Number QR Labels
                                    </button>
                                    &nbsp;
                                </>
                            )}
                        </div>

                        <div className="columns">
                            <div className="column">
                                {(props.orderNumber && orderType !== "ETK") && (
                                    <>
                                        <button
                                            className="button is-primary"
                                            onClick={props.handlePrintOrderNumber}
                                            type="button"
                                        >
                                            Order Number
                                        </button>
                                        &nbsp;
                                        <button
                                            className="button is-primary"
                                            onClick={props.handlePrint}
                                            type="button"
                                        >
                                            Sample Barcode
                                        </button>
                                        &nbsp;
                                        <button
                                            className="button is-primary"
                                            onClick={props.handleCheckInPrint}
                                            type="button"
                                        >
                                            Check-In Label
                                        </button>
                                    </>
                                )}
                            </div>
                            <div className="column align-right has-text-right">
                                <input
                                    type="submit"
                                    className="button is-success"
                                    disabled={!formState.isValid || props.orderNumber}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            {showDialog && (
                <NewOrderFileUploadDialog
                    time={props.time}
                    user={props.user}
                    accountNumber={props.accountNumber}
                    onClose={handleDialogClose}
                />
            )}
        </>
    );
}
